import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BeoButton } from "@components/common/action";
import getButtonModes from "@components/common/action/BeoButton/ButtonModeFactory";
import { BeoInputText } from "@components/common/input";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
/**
 * The method that generates random captcha of 6 characters
 *
 * @returns captcha
 */
var generateCaptcha = function () {
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var captcha = "";
    for (var i = 0; i < 6; i++) {
        captcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return captcha;
};
/**
 * Generic component for Captcha
 * @param onVerify The callback hook returns if the captcha is verified on real-time
 * @param isFailed The flag to reset the captcha if fails
 * @param onResetFail The callback hook to reset the isFailed flag
 * @returns BeoCaptcha
 */
var BeoCaptcha = function (_a) {
    var onVerify = _a.onVerify, isFailed = _a.isFailed, onResetFail = _a.onResetFail;
    var _b = useState(generateCaptcha()), captcha = _b[0], setCaptcha = _b[1];
    var _c = useState(""), userInput = _c[0], setUserInput = _c[1];
    var canvasRef = useRef(null);
    /**
     * The method to draw captcha inside a canvas with some random lines on it
     */
    var drawCaptcha = function () {
        var canvas = canvasRef.current;
        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = "26px monospace";
        ctx.fillStyle = "#333";
        ctx.fillText(captcha, 10, 30);
        for (var i = 0; i < 4; i++) {
            ctx.strokeStyle = "rgba(0,0,0,".concat(Math.random(), ")");
            ctx.beginPath();
            ctx.moveTo(Math.random() * 100, Math.random() * 50);
            ctx.lineTo(Math.random() * 150, Math.random() * 50);
            ctx.stroke();
        }
    };
    /**
     * To draw captcha, once the component is mounted
     */
    useEffect(function () {
        drawCaptcha();
    }, [captcha]);
    /**
     * Method to refresh captcha
     * @returns
     */
    var refreshCaptcha = function () { return setCaptcha(generateCaptcha()); };
    /**
     * To reset captcha if attempt is failed
     */
    useEffect(function () {
        if (isFailed) {
            refreshCaptcha();
            onResetFail === null || onResetFail === void 0 ? void 0 : onResetFail();
            setUserInput("");
        }
    }, [isFailed, refreshCaptcha]);
    /**
     * To verify the captcha on real-time
     * @param e The event
     */
    var handleVerify = function (e) {
        var value = e.target.value;
        setUserInput(value);
        if (value === captcha) {
            onVerify === null || onVerify === void 0 ? void 0 : onVerify(true);
        }
        else {
            onVerify === null || onVerify === void 0 ? void 0 : onVerify(false);
        }
    };
    var t = useTranslation().t;
    var ButtonModes = getButtonModes(t);
    return (_jsxs("div", { className: "text-center my-4", children: [_jsxs("div", { className: "mt-2 flex items-center justify-center gap-2", children: [_jsx("canvas", { ref: canvasRef, width: "200", height: "50", style: { border: "1px solid #ccc" } }), _jsx(BeoButton, { id: "refreshCaptcha", onClick: refreshCaptcha, buttontype: ButtonModes.RefreshWithIcon })] }), _jsx("div", { className: "mt-2", children: _jsx(BeoInputText, { id: "captchaInput", placeholder: "Enter CAPTCHA", value: userInput, onChange: handleVerify }) })] }));
};
export default BeoCaptcha;
